import script from "./Level.vue?vue&type=script&setup=true&lang=js"
export * from "./Level.vue?vue&type=script&setup=true&lang=js"

import "./Level.vue?vue&type=style&index=0&id=00cff219&scoped=true&lang=css"

import exportComponent from "C:\\Users\\ga38som\\IdeaProjects\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-00cff219"]])

export default __exports__